/* global YT */

const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the youtube player component
 */

app.directive('youtubePlayer', ['Analyze', function (Analyze) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      source: '=',
      mediaId: '=',
      tracking: '=?',
      onComplete: '&?',
      completionPercent: '=?'
    },
    template: require('../../templates/directives/youtube-player.html'),
    link: function (scope, element, attrs) {
      var self = this;
      var loadApi = function () {
        var searchScript = document.getElementById('ytplayersource');
        if (searchScript) {
          playerInfo.onYouTubeIframeAPIReady();
          return;
        }
        var tag = document.createElement('script');
        tag.id = 'ytplayersource';
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = playerInfo.onYouTubeIframeAPIReady;
      };

      var playerInfo = {
        player: null,
        onYouTubeIframeAPIReady: function() {
          playerInfo.player = new YT.Player('ytplayer', {
            height: attrs.height,
            width: attrs.width,
            videoId: scope.source,
            events: {
              'onReady': playerInfo.onPlayerReady,
              'onStateChange': playerInfo.onPlayerStateChange
            }
          });
        },
        initialized: false,
        seekTo: null,
        onPlayerReady: function(event) {
          if (playerInfo.seekTo && typeof playerInfo.seekTo === 'number') {
            playerInfo.player.seekTo(playerInfo.player.getDuration() * (playerInfo.seekTo / 100));
          }
          playerInfo.initialized = true;
        },
        onPlayerStateChange: function(event) {
          if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
            playerInfo.recordPosition();
          }
        },
        recordPosition: function() {
          if (!scope.mediaId) {
            return;
          }
          var percent = playerInfo.player.getCurrentTime() / playerInfo.player.getDuration() * 100;
          Analyze.record({resource: 'user-videos'}, {content: scope.mediaId, position: percent}).$promise.then(function(item) {});
          scope.tracking.checkFurthest(percent);
          if (scope.completionPercent && scope.onComplete && typeof scope.completionPercent === 'number' && percent > scope.completionPercent) {
            scope.onComplete();
          }
        }
      };

      scope.$on('$destroy', function() {
        playerInfo.recordPosition();
      });

      self.initialize = function() {
        playerInfo.initialized = false;
        var ratio = (attrs.height / attrs.width) * 100;
        element[0].style.paddingTop = ratio + '%';
        loadApi();
        if (scope.mediaId) {
          Analyze.userVideos({subresource: scope.mediaId}).$promise
          .then(function(item) {
            if (typeof scope.completionPercent === 'number' && typeof item.furthest_position === 'number' && item.furthest_position > scope.completionPercent) {
              scope.onComplete();
            }
            if (!item || !item.last_position) {
              scope.tracking.setInitialPosition(0);
              return;
            }
            scope.tracking.setInitialPosition(item.last_position);
            if (!playerInfo.initialized) {
              playerInfo.seekTo = item.last_position;
              return;
            }
            playerInfo.player.seekTo(playerInfo.player.getDuration() * (item.last_position / 100));
          });
        }
      };

      if (scope.source) {
        self.initialize();
      }
    }
  };

}]);